// extracted by mini-css-extract-plugin
export default {"PageContainerCss":"PageContainer_PageContainerCss__MQcgv"};